/**
 * Time constants expressed in milliseconds
 */

export const ONE_MINUTE = 1 * 60 * 1000;
export const FIVE_MINUTES = 5 * ONE_MINUTE;
